import { Action } from '@ngrx/store';
import { Reference } from 'src/app/core/utils/action-helper.util';
import { CopyRolePayload, CopyRoleResponse } from '../../_models/settings.models';

/**
 * Application User action types
 */
export enum RolesActionTypes {
  LOAD_ROLES = '[Roles] Load Roles',
  LOAD_ROLES_SUCCESS = '[Roles] Load Roles Success',
  LOAD_ROLES_FAILED = '[Roles] Load Roles Failed',
  LOAD_ROLE_DETAIL = '[Roles] Load Roles Details',
  LOAD_ROLE_DETAIL_SUCCESS = '[Roles] Load Roles Details Success',
  LOAD_ROLE_DETAIL_FAILED = '[Roles] Load Roles Details Failed',
  LOAD_MANAGEMENT_TYPES = '[Roles] Load Management Types',
  LOAD_MANAGEMENT_TYPES_SUCCESS = '[Roles] Load Management Types Success',
  LOAD_MANAGEMENT_TYPES_FAILED = '[Roles] Load Management Types Failed',
  CREATE_ROLE = '[Roles] Create Role',
  CREATE_ROLE_SUCCESS = '[Roles] Create Role Success',
  CREATE_ROLE_FAILED = '[Roles] Create Role Failed',
  DELETE_ROLE = '[Roles] Delete Role',
  DELETE_ROLE_SUCCESS = '[Roles] Delete Role Sucess',
  DELETE_ROLE_FAILED = '[Roles] Delete Role Failed',
  UPDATE_ROLE = '[Roles] Update Role',
  UPDATE_ROLE_SUCCESS = '[Roles] Update Role Success',
  UPDATE_ROLE_FAILED = '[Roles] Update Role Failed',
  RESET = '[Roles] RESET',

  COPY_ROLE = '[Roles] Copy Role',
  COPY_ROLE_SUCCESS = '[Roles] Copy Role Success',
  COPY_ROLE_FAILED = '[Roles] Copy Role Failed',
}

/**
 * Operations
 */

export class LoadRoles implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadRolesSuccess implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES_SUCCESS;

  constructor(public applicationId: string, public payload: Array<any>) {}
}

export class LoadRolesFailed implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES_FAILED;

  constructor(public payload: Error, public applicationId: string) {}
}

export class LoadRoleDetail implements Action {
  readonly type = RolesActionTypes.LOAD_ROLE_DETAIL;

  constructor(public appId: string, public roleId: string) {}
}

export class LoadRoleDetailSuccess implements Action {
  readonly type = RolesActionTypes.LOAD_ROLE_DETAIL_SUCCESS;

  constructor(
    public appId: string,
    public roleId: string,
    public payload: any
  ) {}
}

export class LoadRoleDetailFailed implements Action {
  readonly type = RolesActionTypes.LOAD_ROLE_DETAIL_FAILED;

  constructor(public payload: any) {}
}

export class LoadManagementTypes implements Action {
  readonly type = RolesActionTypes.LOAD_MANAGEMENT_TYPES;

  constructor() {}
}

export class LoadManagementTypesSuccess implements Action {
  readonly type = RolesActionTypes.LOAD_MANAGEMENT_TYPES_SUCCESS;

  constructor(public payload: any) {}
}

export class LoadManagementTypesFailed implements Action {
  readonly type = RolesActionTypes.LOAD_MANAGEMENT_TYPES_FAILED;

  constructor(public payload: any) {}
}

export class CreateRole implements Action {
  readonly type = RolesActionTypes.CREATE_ROLE;

  constructor(public payload: any) {}
}

export class CreateRoleSuccess implements Action {
  readonly type = RolesActionTypes.CREATE_ROLE_SUCCESS;

  constructor(public appId: string) {}
}

export class CreateRoleFailed implements Action {
  readonly type = RolesActionTypes.CREATE_ROLE_FAILED;

  constructor(public payload: any) {}
}

export class DeleteRole extends Reference implements Action {
  readonly type = RolesActionTypes.DELETE_ROLE;

  constructor(public roleId: any) {
    super();
  }
}

export class DeleteRoleSuccess extends Reference implements Action {
  readonly type = RolesActionTypes.DELETE_ROLE_SUCCESS;

  constructor(public appId: any) {
    super();
  }
}

export class DeleteRoleFailed extends Reference implements Action {
  readonly type = RolesActionTypes.DELETE_ROLE_FAILED;

  constructor(public payload: any) {
    super();
  }
}

export class UpdateRole implements Action {
  readonly type = RolesActionTypes.UPDATE_ROLE;

  constructor(public payload: any) {}
}

export class UpdateRoleSuccess implements Action {
  readonly type = RolesActionTypes.UPDATE_ROLE_SUCCESS;

  constructor(public appId: string) {}
}

export class UpdateRoleFailed implements Action {
  readonly type = RolesActionTypes.UPDATE_ROLE_FAILED;

  constructor(public payload: any) {}
}

export class Reset implements Action {
  readonly type = RolesActionTypes.RESET;

  constructor() {}
}

/** 
*COPY ROLE 
*/
export class CopyRole extends Reference implements Action {
  readonly type = RolesActionTypes.COPY_ROLE;

  constructor(public applicationId: string, public payload: CopyRolePayload) {
    super();
  }
}

export class CopyRoleSuccess extends Reference implements Action {
  readonly type = RolesActionTypes.COPY_ROLE_SUCCESS;

  constructor(public payload: CopyRoleResponse) {
    super();
  }
}

export class CopyRoleFailed extends Reference implements Action {
  readonly type = RolesActionTypes.COPY_ROLE_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

/**
 * Available types
 */
export type Actions =
  | LoadRoles
  | LoadRolesSuccess
  | LoadRolesFailed
  | LoadRoleDetail
  | LoadRoleDetailSuccess
  | LoadRoleDetailFailed
  | LoadManagementTypes
  | LoadManagementTypesSuccess
  | LoadManagementTypesFailed
  | CreateRole
  | CreateRoleSuccess
  | CreateRoleFailed
  | UpdateRole
  | UpdateRoleSuccess
  | UpdateRoleFailed
  | DeleteRole
  | DeleteRoleSuccess
  | DeleteRoleFailed
  | CopyRole
  | CopyRoleSuccess
  | CopyRoleFailed
  | Reset
  ;
